export const profileResponse = {
	id: 'some-id',
	age: 30,
	weight: 168,
	height: 80,
	biological_sex: 'male',
	email: 'nathan@n8n.io',
};
